import { z } from 'zod';

import {
  cashConfigProvenanceValues,
  cashLocationStatusValues,
  cashLocationTypeValues,
  type CashConfigProvenance,
  type CashLocationDto,
  type CashLocationStatus,
  type CashLocationType,
  type CreateCashLocationRequest,
  type CreateCashLocationResponse,
  type DisableCashLocationRequest,
  type DisableCashLocationResponse,
  type ListCashLocationsRequest,
  type ListCashLocationsResponse,
} from './cash-locations.dto.js';

const timestampSchema = z.iso.datetime();

export const CashLocationTypeSchema: z.ZodType<CashLocationType> = z.enum(cashLocationTypeValues);
export const CashLocationStatusSchema: z.ZodType<CashLocationStatus> =
  z.enum(cashLocationStatusValues);
export const CashConfigProvenanceSchema: z.ZodType<CashConfigProvenance> = z.enum(
  cashConfigProvenanceValues,
);

export const CashLocationDtoSchema: z.ZodType<CashLocationDto> = z.object({
  id: z.uuid(),
  companyId: z.uuid(),
  storeId: z.uuid().nullable(),
  locationId: z.uuid().nullable(),
  stationId: z.uuid().nullable(),
  name: z.string().trim().min(1).max(200),
  type: CashLocationTypeSchema,
  status: CashLocationStatusSchema,
  provenance: CashConfigProvenanceSchema,
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

export const CreateCashLocationRequestSchema: z.ZodType<CreateCashLocationRequest> = z.object({
  companyId: z.uuid(),
  operationId: z.uuid(),
  occurredAt: timestampSchema.optional(),
  name: z.string().trim().min(1).max(200),
  type: CashLocationTypeSchema,
  storeId: z.uuid().optional(),
  locationId: z.uuid().optional(),
  stationId: z.uuid().optional(),
});

export const CreateCashLocationResponseSchema: z.ZodType<CreateCashLocationResponse> = z.object({
  cashLocation: CashLocationDtoSchema,
});

export const ListCashLocationsRequestSchema: z.ZodType<ListCashLocationsRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid().optional(),
  locationId: z.uuid().optional(),
  stationId: z.uuid().optional(),
  type: CashLocationTypeSchema.optional(),
  status: CashLocationStatusSchema.optional(),
});

export const ListCashLocationsResponseSchema: z.ZodType<ListCashLocationsResponse> = z.object({
  items: z.array(CashLocationDtoSchema),
});

export const DisableCashLocationRequestSchema: z.ZodType<DisableCashLocationRequest> = z.object({
  companyId: z.uuid(),
  cashLocationId: z.uuid(),
  operationId: z.uuid(),
  occurredAt: timestampSchema.optional(),
});

export const DisableCashLocationResponseSchema: z.ZodType<DisableCashLocationResponse> = z.object({
  cashLocation: CashLocationDtoSchema,
});
